import { MEMBERS_AREA_LABELS } from '@/consts/product-settings';
import { MEMBER_AREA_COPY_STATUS } from '@/sections/@dashboard/product-members-area/ProductMembersAreaV2/utils/membersAreaCopy.utils';

export const DUPLICATE_PRODUCT_TEXTS = {
  title: 'Duplicar produto',
  whatGoes:
    'A cópia leva checkouts, ofertas, links, order bumps, pixels e, se houver, toda a área de membros: cursos, módulos, aulas, materiais, aparência, certificados e planos de acesso.',
  whatGoesWithoutMembersArea: 'A cópia leva checkouts, ofertas, links, order bumps e pixels.',
  largeArea:
    'Se a área de membros for grande, ela é copiada em segundo plano e você recebe um e-mail quando estiver pronta.',
  whatStays:
    'Alunos, progresso, comentários, afiliados, coprodutores e cupons ficam só no produto original.',
  cancel: 'Cancelar',
  confirm: 'Duplicar',
  success: 'Produto duplicado com sucesso',
  copying:
    'Produto duplicado. A área de membros está sendo copiada e você vai receber um e-mail quando ela estiver pronta.',
  error: 'Não foi possível duplicar o produto.',
  retry: 'Tente novamente.',
};

export const DUPLICATE_PRODUCT_COPYING_NOTICE_DURATION_MS = 10000;

const MEMBERS_AREA_V3_DELIVERY = 'cakto_v3';
const LEGACY_MEMBERS_AREA_DELIVERIES = ['cakto', 'cakto_v2'];

export function buildLegacyMembersAreaNotCopiedText(legacyDeliveries) {
  const labels = legacyDeliveries.map((delivery) => MEMBERS_AREA_LABELS[delivery]).join(' e ');

  return `A área de membros da ${labels} não vai para a cópia.`;
}

export function resolveDuplicateProductParagraphs(contentDeliveries) {
  const deliveries = Array.isArray(contentDeliveries) ? contentDeliveries : [];
  const legacyDeliveries = LEGACY_MEMBERS_AREA_DELIVERIES.filter((delivery) =>
    deliveries.includes(delivery)
  );

  if (legacyDeliveries.length === 0) {
    return [
      DUPLICATE_PRODUCT_TEXTS.whatGoes,
      DUPLICATE_PRODUCT_TEXTS.largeArea,
      DUPLICATE_PRODUCT_TEXTS.whatStays,
    ];
  }

  const hasMembersAreaV3 = deliveries.includes(MEMBERS_AREA_V3_DELIVERY);

  return [
    hasMembersAreaV3
      ? DUPLICATE_PRODUCT_TEXTS.whatGoes
      : DUPLICATE_PRODUCT_TEXTS.whatGoesWithoutMembersArea,
    ...(hasMembersAreaV3 ? [DUPLICATE_PRODUCT_TEXTS.largeArea] : []),
    buildLegacyMembersAreaNotCopiedText(legacyDeliveries),
    DUPLICATE_PRODUCT_TEXTS.whatStays,
  ];
}

export function resolveDuplicateProductNotice(duplicatedProduct) {
  if (duplicatedProduct?.member_area_copy?.status === MEMBER_AREA_COPY_STATUS.copying) {
    return {
      variant: 'info',
      message: DUPLICATE_PRODUCT_TEXTS.copying,
      options: { autoHideDuration: DUPLICATE_PRODUCT_COPYING_NOTICE_DURATION_MS },
    };
  }

  return { variant: 'success', message: DUPLICATE_PRODUCT_TEXTS.success };
}

export function buildDuplicateProductErrorMessage(error) {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  const isClientError = status >= 400 && status < 500;
  const reason = isClientError && typeof detail === 'string' ? detail.trim() : '';

  return `${DUPLICATE_PRODUCT_TEXTS.error} ${reason || DUPLICATE_PRODUCT_TEXTS.retry}`;
}
